const matchSingleParentUnitId = (subUnitObject, unitId) => subUnitObject.parent_id == unitId;

const matchMultiParentUnitIds = (subUnitObject, unitId) => {
    if (subUnitObject.parent_unit_ids == '') return false;

    // split the comma delimited sub-unit parent_unit_ids string into an array, trim whitespace, and filter out any empty values
    // TODO: Find where this string is being created and remove the whitespace there to simplify this process
    const ids = subUnitObject.parent_unit_ids
        .split(',')
        .map(id => id.trim())
        .filter(Boolean);

    return ids.includes(String(unitId));
}

const getFirstAvSubUnitFromArr = (availableSubUnits) => {
    if (availableSubUnits.length == 0)
        return null;

    let firstAllocatable = 10000;
    let firstAvailable = 0;

    // hide every unavailable dropdown option    
    availableSubUnits.forEach(subUnit => {
        const allocOrder = parseIntb10(subUnit.position);

        if (allocOrder < firstAllocatable) {
            firstAllocatable = allocOrder;
            firstAvailable = subUnit;
        }
    });

    return firstAvailable;
}

const getAvailablePitchTypes = (availableSubUnits = [], pitchTypes = []) => {
    const availablePitchTypeIds = new Set(
        availableSubUnits
            .map(subUnit => parseInt(subUnit.pitch_type, 10))
            .filter(pitchTypeId => pitchTypeId > 0)
    );

    return pitchTypes.filter(pitchType =>
        availablePitchTypeIds.has(parseInt(pitchType.id, 10))
    );
}

const shouldShowPitchTypeFilter = (unit, subUnitsAreHidden, availablePitchTypes = []) =>
    parseInt(unit?.multi_alloc_flag, 10) === 1 &&
    Boolean(subUnitsAreHidden) &&
    availablePitchTypes.length > 1;

const shouldShowPitchMap = (unit, availableSubUnits = null) => {
    const isMapEnabledForUnit = parseInt(unit?.pitch_map, 10) === 1;
    const isParentUnit = parseInt(unit?.single_plot, 10) === 0;
    const hasAvailability = !isParentUnit || availableSubUnits === null || availableSubUnits.length > 0;

    return isMapEnabledForUnit && hasAvailability;
};

export {
    matchSingleParentUnitId,
    matchMultiParentUnitIds,
    getFirstAvSubUnitFromArr,
    getAvailablePitchTypes,
    shouldShowPitchTypeFilter,
    shouldShowPitchMap
};
